import { Input } from '@mantine/core'
import React from 'react'
import { colors } from 'settings/colors'

export const InputWrapper = (props: {
  children: React.ReactNode
  description?: React.ReactNode
  error: boolean
  errorMessage?: React.ReactNode
  label: React.ReactNode
}) => {
  return (
    <Input.Wrapper
      inputWrapperOrder={['label', 'description', 'input', 'error']}
      label={
        <h3 css={{ color: props.error ? colors.red : colors.midnight, margin: '0 0 10px 0' }}>
          {props.label}
        </h3>
      }
      error={props.errorMessage || <>&nbsp;</>}
      description={
        props.description ? (
          <span
            css={{
              display: 'block',
              color: props.error ? colors.red : colors.midnight,
              fontSize: 14,
              margin: '0 0 10px 0',
            }}
          >
            {props.description}
          </span>
        ) : undefined
      }
    >
      {props.children}
    </Input.Wrapper>
  )
}
